module.exports = __webpack_public_path__ + "static/media/icon_130.faaeeeef.svg";